import { takeLatest, put, call } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { Exercise } from '../types'
import {
  FETCH_EXERCISES_FAIL,
  CREATE_EXERCISE,
  CreateExerciseActionType,
  CREATE_EXERCISE_SUCCESS
} from '../redux/exercisesReducer'

function* CreateExerciseFlow(action: CreateExerciseActionType): Generator<any, void, any> {
  try {
    const response: Exercise = yield call(apiCall, {
      endpoint: `/tutors/lesson_plans/${action.payload.lessonPlanId}/exercises`,
      method: 'POST',
      params: {
        exercise: {
          question: action.payload.question,
          answer: action.payload.answer,
          question_type: action.payload.question_type
        }
      }
    })
    yield put(CREATE_EXERCISE_SUCCESS({ lessonPlanId: action.payload.lessonPlanId, exercise: response }))
  } catch (error) {
    yield put(FETCH_EXERCISES_FAIL())
    console.log(error)
  }
}

export default function* CreateExerciseSaga(): Generator<any, void, any> {
  yield takeLatest([CREATE_EXERCISE], CreateExerciseFlow)
}
